import { render, staticRenderFns } from "./teacherExam.vue?vue&type=template&id=2448860f&scoped=true&"
import script from "./teacherExam.vue?vue&type=script&lang=js&"
export * from "./teacherExam.vue?vue&type=script&lang=js&"
import style0 from "./teacherExam.vue?vue&type=style&index=0&id=2448860f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2448860f",
  null
  
)

export default component.exports